module.exports = __webpack_public_path__ + "img/zhizheng_1@3x.625c0a35.png";